import type { ComponentType } from 'react';
import { ProductMenuConfigurationPage } from '@/pages/Admin/menu/ProductMenuConfigurationPage';
import { ProductManagementPage } from '@/pages/Admin/products/ProductManagementPage';
import { NotificationCenterPage } from '@/pages/NotificationCenterPage';

export const adminModuleComponents: Record<string, ComponentType> = {
  'product-management': ProductManagementPage,
  'product-menu-management': ProductMenuConfigurationPage,
  notifications: NotificationCenterPage,
};
